import { combineReducers } from 'redux';
import dialog from './dialog';

export default combineReducers({
  dialog,
});
